/*
  Inner Botanica – Doctor Visit Kit: application logic.
  Content/lexicons live in doctor-kit-data.js (window.IB_DK_DATA).
  Settings/asset URLs come from the section (window.IB_DK_CONFIG).

  Privacy contract: answers live in memory + sessionStorage only. They are
  never transmitted. Analytics carry event names + step ids only — never
  answer content. Free text renders via textContent only (never innerHTML)
  and is never paraphrased.
*/
(function () {
  "use strict";

  var DATA = window.IB_DK_DATA;
  var CONFIG = window.IB_DK_CONFIG || {};
  var S = DATA.strings;
  var STORE_KEY = "ib_dk_state_v1";

  /* ------------------------------------------------------------ lookups */
  function indexBy(list) {
    var m = {};
    list.forEach(function (x) { m[x.id] = x; });
    return m;
  }
  var SYM = indexBy(DATA.symptoms);
  var CYCLE = indexBy(DATA.cycle);
  var TRIED = indexBy(DATA.tried.chips);
  var OUTCOME = indexBy(DATA.tried.outcomes);
  var FAMILY = indexBy(DATA.family);
  var DEEP_ITEMS = {};
  DATA.deepSweep.forEach(function (g) {
    g.items.forEach(function (it) { DEEP_ITEMS[it.id] = it; });
  });
  function chipPhrase(list, id) {
    var hit = list.filter(function (c) { return c.id === id; })[0];
    return hit ? hit.phrase : "";
  }
  var SCREEN_DEFS = {};
  DATA.screens.forEach(function (d) { SCREEN_DEFS[d.id] = d; });

  /* -------------------------------------------------------------- state */
  function freshAnswers() {
    return {
      v: 1,
      sym: [], symO: "",
      pri: [],
      det: {},
      tried: { c: [], o: "", out: "" },
      meds: { t: "", none: false },
      cyc: "",
      goal: { c: "", t: "" }
      /* .deep added only on opt-in */
    };
  }
  var state = {
    answers: freshAnswers(),
    screen: "intro",
    history: [],
    fromShare: false
  };

  /* ------------------------------------------------------------ persist */
  var memStore = null;
  function save() {
    var payload = JSON.stringify({
      answers: state.answers,
      screen: state.screen,
      history: state.history
    });
    try { sessionStorage.setItem(STORE_KEY, payload); }
    catch (e) { memStore = payload; }
  }
  function load() {
    var raw = null;
    try { raw = sessionStorage.getItem(STORE_KEY); } catch (e) { raw = memStore; }
    if (!raw) return null;
    try {
      var parsed = JSON.parse(raw);
      if (parsed && parsed.answers && parsed.answers.v === 1) return parsed;
    } catch (e) { /* corrupt — ignore */ }
    return null;
  }
  function clearSaved() {
    try { sessionStorage.removeItem(STORE_KEY); } catch (e) { /* noop */ }
    memStore = null;
  }

  /* ---------------------------------------------------------- analytics
     Step ids only. Never answer content. */
  function track(event, stepId) {
    try {
      var payload = { event: event };
      if (stepId) payload.step_id = stepId;
      (window.dataLayer = window.dataLayer || []).push(payload);
      document.dispatchEvent(new CustomEvent("funnelocity:kit-event", {
        detail: { event: event, step_id: stepId || null }
      }));
    } catch (e) { /* analytics must never break the flow */ }
  }

  /* --------------------------------------------------------- dom helpers */
  function byId(id) { return document.getElementById(id); }
  function h(tag, cls, text) {
    var node = document.createElement(tag);
    if (cls) node.className = cls;
    if (text !== undefined && text !== null) node.textContent = text;
    return node;
  }
  function btn(cls, label, onClick) {
    var b = h("button", cls, label);
    b.type = "button";
    b.addEventListener("click", onClick);
    return b;
  }

  /* ----------------------------------------------------------- symptoms */
  function symLabel(id) {
    if (id === "other") {
      var t = state.answers.symO || "";
      return t.length > 48 ? t.slice(0, 48) + "…" : t;
    }
    return SYM[id] ? SYM[id].label : id;
  }
  function symTerm(answers, id) {
    if (id === "other") return "“" + (answers.symO || "") + "”";
    return SYM[id] ? SYM[id].term : id;
  }

  /* ---------------------------------------------------------------- path
     The effective screen sequence given current answers. Entries are
     instance keys: "s1", "s2", "detail:<symId>", "s6" … "d6". */
  function buildPath() {
    var p = ["s1"];
    if (state.answers.sym.length > 3) p.push("s2");
    state.answers.pri.forEach(function (id) { p.push("detail:" + id); });
    p = p.concat(["s6", "s7", "s8", "s9", "s10"]);
    if (state.answers.deep) p = p.concat(["d1", "d2", "d3", "d4", "d5", "d6"]);
    return p;
  }
  function nextKey(afterKey) {
    var p = buildPath();
    var i = p.indexOf(afterKey);
    return i === -1 || i + 1 >= p.length ? null : p[i + 1];
  }

  /* --------------------------------------------------------- view states */
  var VIEW_IDS = ["ib-dk-intro", "ib-dk-interview", "ib-dk-transition", "ib-dk-reveal", "ib-dk-after"];
  function showView(id) {
    VIEW_IDS.forEach(function (v) {
      var node = byId(v);
      if (node) node.classList.toggle("is-active", v === id);
    });
    var progress = byId("ib-dk-progress");
    if (progress) progress.hidden = id !== "ib-dk-interview";
    window.scrollTo(0, 0);
  }

  /* --------------------------------------------------------------- router */
  function parseKey(key) {
    var parts = key.split(":");
    return parts[0] === "detail"
      ? { def: SCREEN_DEFS.detail, symId: parts[1], id: "detail" }
      : { def: SCREEN_DEFS[parts[0]], symId: null, id: parts[0] };
  }
  function go(key, opts) {
    opts = opts || {};
    var inst = parseKey(key);
    if (!inst.def) return;
    if (!opts.silent) {
      if (state.screen !== key) state.history.push(state.screen);
      state.screen = key;
    }
    showView("ib-dk-interview");
    renderScreen(inst);
    updateProgress(key);
    track("kit_step", key.replace(":", "_"));
    save();
  }
  function goBack() {
    var prev = state.history.pop();
    if (!prev || prev === "intro") {
      state.screen = "intro";
      showView("ib-dk-intro");
      save();
      return;
    }
    state.screen = prev;
    var inst = parseKey(prev);
    showView("ib-dk-interview");
    renderScreen(inst);
    updateProgress(prev);
    save();
  }
  function advance(fromKey) {
    var nk = nextKey(fromKey);
    if (nk) { go(nk); return; }
    /* end of path */
    if (state.answers.deep) track("kit_deep_complete");
    reveal();
  }
  function updateProgress(key) {
    var p = buildPath();
    var i = p.indexOf(key);
    var fill = byId("ib-dk-progress-fill");
    if (fill && i !== -1) fill.style.width = Math.round(((i + 1) / (p.length + 1)) * 100) + "%";
  }

  /* ------------------------------------------------------------ renderers */
  function screenShell(inst) {
    var mount = byId("ib-dk-screen");
    mount.textContent = "";
    var card = h("div", "ib-dk-card");
    var head = h("h2", "ib-dk-card__prompt");
    head.tabIndex = -1;
    if (inst.id === "detail") {
      head.textContent = S.detailHeaderPrefix;
      var em = h("span", "ib-dk-card__prompt-symptom", symLabel(inst.symId));
      head.appendChild(em);
    } else {
      head.textContent = inst.def.prompt;
    }
    card.appendChild(head);
    if (inst.def.sub) card.appendChild(h("p", "ib-dk-card__sub", inst.def.sub));
    mount.appendChild(card);
    window.requestAnimationFrame(function () { head.focus(); });
    return card;
  }
  function footerNav(card, key, nextEnabled, onNext, nextLabel) {
    var foot = h("div", "ib-dk-card__footer");
    foot.appendChild(btn("ib-dk-btn ib-dk-btn--ghost", S.back, goBack));
    var next = btn("ib-dk-btn ib-dk-btn--primary", nextLabel || S.next, onNext);
    next.disabled = !nextEnabled;
    foot.appendChild(next);
    card.appendChild(foot);
    return next;
  }
  function chipButton(label, pressed, onToggle) {
    var c = btn("ib-dk-chip", label, function () { onToggle(c); });
    c.setAttribute("aria-pressed", pressed ? "true" : "false");
    if (pressed) c.classList.add("is-on");
    return c;
  }
  function setPressed(node, on) {
    node.setAttribute("aria-pressed", on ? "true" : "false");
    node.classList.toggle("is-on", !!on);
  }

  /* chips (S1, S6, D1, D4) */
  function renderChips(inst) {
    var def = inst.def;
    var a = state.answers;
    var selected = def.key === "sym" ? a.sym
      : def.key === "tried" ? a.tried.c
      : def.key === "sweep" ? a.deep.sweep
      : a.deep.fam;
    function setSelected(list) {
      if (def.key === "sym") a.sym = list;
      else if (def.key === "tried") a.tried.c = list;
      else if (def.key === "sweep") a.deep.sweep = list;
      else a.deep.fam = list;
      save();
    }

    var card = screenShell(inst);
    var wrap = h("div", "ib-dk-chips");
    var nextBtn;
    function refreshNext() {
      var min = def.min || 0;
      var count = selected.filter(function (id) { return id !== "other" || (a.symO || "").trim(); }).length;
      if (nextBtn) nextBtn.disabled = count < min;
    }
    function toggle(id, node) {
      var i = selected.indexOf(id);
      if (i === -1) selected.push(id); else selected.splice(i, 1);
      /* keep pri consistent with sym */
      if (def.key === "sym") {
        a.pri = a.pri.filter(function (p) { return selected.indexOf(p) !== -1; });
        Object.keys(a.det).forEach(function (k) {
          if (selected.indexOf(k) === -1) delete a.det[k];
        });
      }
      setPressed(node, selected.indexOf(id) !== -1);
      setSelected(selected);
      refreshNext();
    }

    function addChipRow(container, items) {
      items.forEach(function (item) {
        container.appendChild(chipButton(item.label, selected.indexOf(item.id) !== -1, function (node) {
          toggle(item.id, node);
        }));
      });
    }

    if (def.groups) {
      def.groups.forEach(function (g) {
        var groupEl = h("div", "ib-dk-chip-group");
        groupEl.appendChild(h("p", "ib-dk-chip-group__label", g.label));
        var row = h("div", "ib-dk-chips__row");
        addChipRow(row, g.items);
        groupEl.appendChild(row);
        wrap.appendChild(groupEl);
      });
    } else {
      addChipRow(wrap, def.chips);
    }

    /* optional "other" free text (S1, S6) */
    var otherInput = null;
    if (def.other) {
      var isSym = def.key === "sym";
      var getOther = function () { return isSym ? a.symO : a.tried.o; };
      var setOther = function (v) { if (isSym) a.symO = v; else a.tried.o = v; save(); };
      var otherOn = isSym ? selected.indexOf("other") !== -1 : !!getOther();
      var otherChip = chipButton(def.other.label, otherOn, function (node) {
        if (isSym) {
          toggle("other", node);
          otherBox.hidden = selected.indexOf("other") === -1;
        } else {
          var on = otherBox.hidden;
          otherBox.hidden = !on;
          setPressed(node, on);
          if (!on) setOther("");
        }
        if (!otherBox.hidden) otherInput.focus();
        refreshNext();
      });
      wrap.appendChild(otherChip);

      var otherBox = h("div", "ib-dk-other");
      otherInput = h("input", "ib-dk-input");
      otherInput.type = "text";
      otherInput.maxLength = def.other.maxlen;
      otherInput.placeholder = def.other.placeholder || "";
      otherInput.setAttribute("aria-label", def.other.label);
      otherInput.value = getOther();
      otherInput.addEventListener("input", function () {
        setOther(otherInput.value);
        refreshNext();
      });
      otherBox.appendChild(otherInput);
      otherBox.hidden = !otherOn;
      wrap.appendChild(otherBox);
    }
    card.appendChild(wrap);

    /* optional follow-up single-select (S6 outcome) */
    if (def.followup) {
      var fu = h("div", "ib-dk-followup");
      fu.appendChild(h("p", "ib-dk-followup__label", def.followup.label));
      var row = h("div", "ib-dk-chips__row");
      def.followup.options.forEach(function (opt) {
        var node = chipButton(opt.label, a.tried.out === opt.id, function (self) {
          a.tried.out = a.tried.out === opt.id ? "" : opt.id;
          Array.prototype.forEach.call(row.children, function (c) { setPressed(c, false); });
          setPressed(self, a.tried.out === opt.id);
          save();
        });
        row.appendChild(node);
      });
      fu.appendChild(row);
      card.appendChild(fu);
    }

    nextBtn = footerNav(card, inst.id, true, function () {
      /* drop an empty "other" selection rather than carrying a blank */
      if (def.key === "sym" && selected.indexOf("other") !== -1 && !(a.symO || "").trim()) {
        a.sym = selected.filter(function (id) { return id !== "other"; });
      }
      if (def.key === "sym" && a.sym.length <= 3) {
        a.pri = a.sym.slice(0, 3);
        save();
      }
      advance(inst.id);
    });
    refreshNext();
  }

  /* rank (S2) */
  function renderRank(inst) {
    var a = state.answers;
    var card = screenShell(inst);
    card.appendChild(h("p", "ib-dk-card__hint", S.rankHint));
    var wrap = h("div", "ib-dk-chips ib-dk-chips--rank");

    function repaint() {
      Array.prototype.forEach.call(wrap.children, function (node) {
        var id = node.getAttribute("data-id");
        var pos = a.pri.indexOf(id);
        var badge = node.querySelector(".ib-dk-chip__badge");
        setPressed(node, pos !== -1);
        badge.textContent = pos === -1 ? "" : String(pos + 1);
      });
      nextBtn.disabled = a.pri.length < 1;
    }
    a.sym.forEach(function (id) {
      var node = btn("ib-dk-chip ib-dk-chip--rank", "", function () {
        var pos = a.pri.indexOf(id);
        if (pos !== -1) { a.pri.splice(pos, 1); delete a.det[id]; }
        else if (a.pri.length < inst.def.max) a.pri.push(id);
        save();
        repaint();
      });
      node.setAttribute("data-id", id);
      node.setAttribute("aria-pressed", "false");
      node.appendChild(h("span", "ib-dk-chip__badge", ""));
      node.appendChild(h("span", "ib-dk-chip__label", symLabel(id)));
      wrap.appendChild(node);
    });
    card.appendChild(wrap);
    var nextBtn = footerNav(card, inst.id, a.pri.length >= 1, function () { advance(inst.id); });
    repaint();
  }

  /* detail (S3–S5) */
  function renderDetail(inst) {
    var a = state.answers;
    var def = inst.def;
    var d = a.det[inst.symId] || { dur: "", freq: "", pat: [], cost: [], txt: "" };
    a.det[inst.symId] = d;

    var card = screenShell(inst);
    def.parts.forEach(function (part) {
      var block = h("div", "ib-dk-detail-part");
      block.appendChild(h("p", "ib-dk-detail-part__label", part.label));
      var row = h("div", "ib-dk-chips__row");
      part.chips.forEach(function (chip) {
        var on = part.multi ? d[part.key].indexOf(chip.id) !== -1 : d[part.key] === chip.id;
        row.appendChild(chipButton(chip.label, on, function (node) {
          if (part.multi) {
            var i = d[part.key].indexOf(chip.id);
            if (i === -1) d[part.key].push(chip.id); else d[part.key].splice(i, 1);
            setPressed(node, d[part.key].indexOf(chip.id) !== -1);
          } else {
            d[part.key] = d[part.key] === chip.id ? "" : chip.id;
            Array.prototype.forEach.call(row.children, function (c) { setPressed(c, false); });
            setPressed(node, d[part.key] === chip.id);
          }
          save();
        }));
      });
      block.appendChild(row);
      card.appendChild(block);
    });

    var freeWrap = h("div", "ib-dk-detail-part");
    freeWrap.appendChild(h("p", "ib-dk-detail-part__label", def.free.label));
    var ta = h("textarea", "ib-dk-textarea");
    ta.maxLength = def.free.maxlen;
    ta.rows = 2;
    ta.value = d.txt || "";
    ta.setAttribute("aria-label", def.free.label);
    ta.addEventListener("input", function () { d.txt = ta.value; save(); });
    freeWrap.appendChild(ta);
    card.appendChild(freeWrap);

    footerNav(card, "detail:" + inst.symId, true, function () { advance("detail:" + inst.symId); });
  }

  /* single (S8, S9, D5) */
  function renderSingle(inst) {
    var a = state.answers;
    var def = inst.def;
    function getVal() {
      if (def.key === "cyc") return a.cyc;
      if (def.key === "goal") return a.goal.c;
      return a.deep.prior;
    }
    function setVal(v) {
      if (def.key === "cyc") a.cyc = v;
      else if (def.key === "goal") a.goal.c = v;
      else a.deep.prior = v;
      save();
    }
    var autoAdvance = !def.free;
    var card = screenShell(inst);
    var list = h("div", "ib-dk-options");
    def.options.forEach(function (opt) {
      var node = chipButton(opt.label, getVal() === opt.id, function (self) {
        setVal(opt.id);
        Array.prototype.forEach.call(list.children, function (c) { setPressed(c, false); });
        setPressed(self, true);
        if (nextBtn) nextBtn.disabled = false;
        if (autoAdvance) window.setTimeout(function () { advance(inst.id); }, 220);
      });
      node.classList.add("ib-dk-chip--block");
      list.appendChild(node);
    });
    card.appendChild(list);

    if (def.free) {
      var freeWrap = h("div", "ib-dk-detail-part");
      freeWrap.appendChild(h("p", "ib-dk-detail-part__label", def.free.label));
      var ta = h("textarea", "ib-dk-textarea");
      ta.maxLength = def.free.maxlen;
      ta.rows = 2;
      ta.value = a.goal.t || "";
      ta.setAttribute("aria-label", def.free.label);
      ta.addEventListener("input", function () { a.goal.t = ta.value; save(); });
      freeWrap.appendChild(ta);
      card.appendChild(freeWrap);
    }
    var nextBtn = null;
    if (!autoAdvance) {
      nextBtn = footerNav(card, inst.id, !!getVal(), function () { advance(inst.id); });
    } else {
      var foot = h("div", "ib-dk-card__footer");
      foot.appendChild(btn("ib-dk-btn ib-dk-btn--ghost", S.back, goBack));
      card.appendChild(foot);
    }
  }

  /* text (S7, D6) */
  function renderText(inst) {
    var a = state.answers;
    var def = inst.def;
    var isMeds = def.key === "meds";
    var card = screenShell(inst);
    var ta = h("textarea", "ib-dk-textarea");
    ta.maxLength = def.maxlen;
    ta.rows = 4;
    ta.placeholder = def.placeholder || "";
    ta.setAttribute("aria-label", def.prompt);
    ta.value = isMeds ? a.meds.t : (a.deep.note || "");
    ta.addEventListener("input", function () {
      if (isMeds) { a.meds.t = ta.value; a.meds.none = false; }
      else a.deep.note = ta.value;
      save();
    });
    card.appendChild(ta);

    var skip = btn("ib-dk-btn ib-dk-btn--ghost ib-dk-skip", def.skipLabel, function () {
      if (isMeds) { a.meds.t = ""; a.meds.none = true; }
      else a.deep.note = "";
      save();
      advance(inst.id);
    });
    card.appendChild(skip);
    footerNav(card, inst.id, true, function () {
      if (isMeds && (a.meds.t || "").trim()) a.meds.none = false;
      advance(inst.id);
    });
  }

  /* multi single-select rows (D2, D3) */
  function renderMulti(inst) {
    var a = state.answers;
    var def = inst.def;
    var obj = def.key === "sleep" ? a.deep.sleep : a.deep.wt;
    var card = screenShell(inst);
    def.parts.forEach(function (part) {
      var block = h("div", "ib-dk-detail-part");
      block.appendChild(h("p", "ib-dk-detail-part__label", part.label));
      var row = h("div", "ib-dk-chips__row");
      part.chips.forEach(function (chip) {
        row.appendChild(chipButton(chip.label, obj[part.key] === chip.id, function (node) {
          obj[part.key] = obj[part.key] === chip.id ? "" : chip.id;
          Array.prototype.forEach.call(row.children, function (c) { setPressed(c, false); });
          setPressed(node, obj[part.key] === chip.id);
          save();
        }));
      });
      block.appendChild(row);
      card.appendChild(block);
    });
    footerNav(card, inst.id, true, function () { advance(inst.id); });
  }

  /* fork (S10) */
  var coreCompleteFired = false;
  function renderFork(inst) {
    var card = screenShell(inst);
    if (!coreCompleteFired) { coreCompleteFired = true; track("kit_core_complete"); }
    var actions = h("div", "ib-dk-fork");
    actions.appendChild(btn("ib-dk-btn ib-dk-btn--primary", inst.def.primary, function () {
      reveal();
    }));
    actions.appendChild(btn("ib-dk-btn ib-dk-btn--secondary", inst.def.secondary, function () {
      track("kit_deep_optin");
      if (!state.answers.deep) {
        state.answers.deep = { sweep: [], sleep: { hrs: "", wakes: "", when: "" }, wt: { chg: "", habits: "" }, fam: [], prior: "", note: "" };
      }
      save();
      go("d1");
    }));
    card.appendChild(actions);
    var foot = h("div", "ib-dk-card__footer");
    foot.appendChild(btn("ib-dk-btn ib-dk-btn--ghost", S.back, goBack));
    card.appendChild(foot);
  }

  function renderScreen(inst) {
    switch (inst.def.type) {
      case "chips": return renderChips(inst);
      case "rank": return renderRank(inst);
      case "detail": return renderDetail(inst);
      case "single": return renderSingle(inst);
      case "text": return renderText(inst);
      case "multi": return renderMulti(inst);
      case "fork": return renderFork(inst);
    }
  }

  /* ==================================================== translation engine
     Pure: answers -> sheet model. Free text passes through verbatim. */
  function detailSentence(d) {
    var bits = [];
    var freq = chipPhrase(DATA.detail.freq, d.freq);
    var dur = chipPhrase(DATA.detail.dur, d.dur);
    if (freq) bits.push(freq);
    if (dur) bits.push("for " + dur);
    var pats = (d.pat || [])
      .map(function (id) { return chipPhrase(DATA.detail.pat, id); })
      .filter(Boolean);
    var s = bits.join(", ");
    if (pats.length) s += (s ? ", " : "") + "pattern: " + pats.join("; ");
    var costs = (d.cost || [])
      .map(function (id) { return chipPhrase(DATA.detail.cost, id); })
      .filter(Boolean);
    if (costs.length) s += (s ? ". " : "") + "Impact: " + costs.join(", ") + ".";
    else if (s) s += ".";
    /* capitalize first letter */
    return s ? s.charAt(0).toUpperCase() + s.slice(1) : "";
  }

  function buildSheetModel(answers) {
    var model = { dateLabel: S.sheet.preparedPrefix + new Date().toLocaleDateString("en-US", { year: "numeric", month: "long", day: "numeric" }), sections: [] };

    /* 2 — Top Concerns */
    if (answers.pri.length) {
      model.sections.push({
        id: "concerns", title: S.sheet.topConcerns, kind: "numbered", lead: true,
        items: answers.pri.map(function (id) { return { text: symTerm(answers, id) }; })
      });
    }

    /* 3 — Symptom Detail */
    var rows = answers.pri.map(function (id) {
      var d = answers.det[id] || {};
      return {
        term: symTerm(answers, id),
        text: detailSentence(d),
        quote: (d.txt || "").trim()
      };
    }).filter(function (r) { return r.term; });
    if (rows.length) {
      model.sections.push({ id: "detail", title: S.sheet.symptomDetail, kind: "detailRows", rows: rows });
    }

    /* 4 — Additional Symptoms Reported */
    var groupItems = {};
    answers.sym.forEach(function (id) {
      if (answers.pri.indexOf(id) !== -1 || id === "other") return;
      var sym = SYM[id];
      if (!sym) return;
      (groupItems[sym.group] = groupItems[sym.group] || []).push(sym.term);
    });
    if (answers.deep) {
      (answers.deep.sweep || []).forEach(function (id) {
        var item = DEEP_ITEMS[id];
        if (!item) return;
        (groupItems[item.group] = groupItems[item.group] || []).push(item.term);
      });
      /* D2/D3 factual lines (structured selections, not conclusions) */
      var sl = answers.deep.sleep || {};
      var slBits = [chipPhrase(DATA.deepSleep.hrs, sl.hrs), chipPhrase(DATA.deepSleep.wakes, sl.wakes), chipPhrase(DATA.deepSleep.when, sl.when)].filter(Boolean);
      if (slBits.length) (groupItems.metabolic = groupItems.metabolic || []).push("Sleep: " + slBits.join(", "));
      var wt = answers.deep.wt || {};
      var chg = chipPhrase(DATA.deepWt.chg, wt.chg);
      if (chg) {
        var habit = chipPhrase(DATA.deepWt.habits, wt.habits);
        (groupItems.metabolic = groupItems.metabolic || []).push("Weight: " + chg + (habit ? ", " + habit : ""));
      }
    }
    var groups = DATA.sheetGroups
      .filter(function (g) { return (groupItems[g.id] || []).length; })
      .map(function (g) { return { title: g.title, items: groupItems[g.id] }; });
    var additionalExtras = [];
    if (answers.sym.indexOf("other") !== -1 && answers.pri.indexOf("other") === -1 && (answers.symO || "").trim()) {
      additionalExtras.push({ verbatim: true, text: (answers.symO || "").trim() });
    }
    if (groups.length || additionalExtras.length) {
      model.sections.push({ id: "additional", title: S.sheet.additional, kind: "groupedList", groups: groups, extras: additionalExtras });
    }

    /* 5 — Menstrual Status */
    var cyc = CYCLE[answers.cyc];
    if (cyc && cyc.phrase) {
      model.sections.push({ id: "cycle", title: S.sheet.menstrual, kind: "line", text: cyc.phrase });
    }

    /* 6 — Approaches Already Tried */
    var triedC = (answers.tried.c || []);
    var triedPhrases = triedC
      .filter(function (id) { return id !== "everything"; })
      .map(function (id) { return TRIED[id] ? TRIED[id].phrase : ""; })
      .filter(Boolean);
    var triedLine = "";
    if (triedPhrases.length) {
      triedLine = triedPhrases.join(", ");
      if (triedC.indexOf("everything") !== -1) triedLine = DATA.tried.everythingPrefix + triedLine;
      triedLine = triedLine.charAt(0).toUpperCase() + triedLine.slice(1) + ".";
    } else if (triedC.indexOf("everything") !== -1) {
      triedLine = "Extensive self-directed efforts across diet, sleep, exercise, and lifestyle.";
    }
    if (triedLine || (answers.tried.o || "").trim()) {
      var sec = { id: "tried", title: S.sheet.tried, kind: "paragraphs", items: [] };
      if (triedLine) sec.items.push({ text: triedLine });
      if ((answers.tried.o || "").trim()) sec.items.push({ verbatim: true, text: (answers.tried.o || "").trim() });
      var out = OUTCOME[answers.tried.out];
      if (out) sec.items.push({ text: out.phrase });
      model.sections.push(sec);
    }

    /* 7 — Current Medications & Supplements */
    var medsText = (answers.meds.t || "").trim();
    if (medsText) {
      model.sections.push({ id: "meds", title: S.sheet.meds, kind: "line", text: medsText, userText: true });
    } else if (answers.meds.none) {
      model.sections.push({ id: "meds", title: S.sheet.meds, kind: "line", text: S.sheet.medsNone });
    }

    /* 8 — Relevant Family History */
    if (answers.deep) {
      var fam = (answers.deep.fam || [])
        .filter(function (id) { return id !== "none"; })
        .map(function (id) { return FAMILY[id] ? FAMILY[id].term : ""; })
        .filter(Boolean);
      if (fam.length) {
        model.sections.push({ id: "family", title: S.sheet.family, kind: "line", text: fam.join(" · ") });
      }
    }

    /* 9 — Patient's Questions */
    model.sections.push({
      id: "questions", title: S.sheet.questions, kind: "numbered",
      items: pickQuestions(answers).map(function (q) { return { text: q.text }; })
    });

    /* D6 note + S9 free text — her words, near the end, before questions?
       Keep after questions is wrong; insert before questions: */
    var noteItems = [];
    if ((answers.goal.t || "").trim()) noteItems.push({ verbatim: true, text: answers.goal.t.trim() });
    if (answers.deep && (answers.deep.note || "").trim()) noteItems.push({ verbatim: true, text: answers.deep.note.trim(), truncatable: true });
    if (noteItems.length) {
      model.sections.splice(model.sections.length - 1, 0, {
        id: "note", title: S.sheet.patientNote.replace(": ", ""), kind: "paragraphs", items: noteItems
      });
    }

    return model;
  }

  /* -------------------------------------------------- questions engine */
  function pickQuestions(answers) {
    var chosen = [];
    var defaultRule = null;
    DATA.questions.forEach(function (rule) {
      if (rule.isDefault) { defaultRule = rule; return; }
      if (chosen.length < 4 && rule.when(answers)) {
        chosen.push({ id: rule.id, text: rule.text(answers) });
      }
    });
    if (chosen.length < 4 && defaultRule) {
      chosen.push({ id: defaultRule.id, text: defaultRule.text(answers) });
    }
    if (chosen.length < 3) {
      DATA.questionPad.forEach(function (padId) {
        if (chosen.length >= 3) return;
        if (chosen.some(function (q) { return q.id === padId; })) return;
        var rule = DATA.questions.filter(function (r) { return r.id === padId; })[0];
        if (rule) {
          /* keep default last */
          chosen.splice(chosen.length - 1, 0, { id: rule.id, text: rule.text(answers) });
        }
      });
    }
    return chosen.slice(0, 4);
  }

  /* --------------------------------------------------- product routing */
  function pickProduct(answers) {
    if (!answers.pri.length) return "none";
    if (answers.pri[0] === DATA.products.awakenTrigger) return "awaken";
    var hit = answers.pri.some(function (id) {
      return DATA.products.stabilityTerritory.indexOf(id) !== -1;
    });
    return hit ? "stability" : "none";
  }

  /* ===================================================== sheet DOM render */
  function renderSheetDOM(model) {
    var root = byId("ib-dk-sheet");
    root.textContent = "";

    var masthead = h("header", "ib-dk-sheet__masthead");
    var titleRow = h("div", "ib-dk-sheet__title-row");
    titleRow.appendChild(h("h3", "ib-dk-sheet__doc-title", S.sheet.title));
    titleRow.appendChild(h("span", "ib-dk-sheet__date", model.dateLabel));
    masthead.appendChild(titleRow);
    var idRow = h("div", "ib-dk-sheet__id-row");
    var nameF = h("span", "ib-dk-sheet__blank-field", S.sheet.nameField);
    nameF.appendChild(h("span", "ib-dk-sheet__blank-rule"));
    var dobF = h("span", "ib-dk-sheet__blank-field", S.sheet.dobField);
    dobF.appendChild(h("span", "ib-dk-sheet__blank-rule ib-dk-sheet__blank-rule--short"));
    idRow.appendChild(nameF);
    idRow.appendChild(dobF);
    masthead.appendChild(idRow);
    root.appendChild(masthead);

    model.sections.forEach(function (sec) {
      var s = h("section", "ib-dk-sheet__section" + (sec.lead ? " ib-dk-sheet__section--lead" : ""));
      s.setAttribute("data-kind", sec.kind);
      s.appendChild(h("h4", "ib-dk-sheet__heading", sec.title));

      if (sec.kind === "numbered") {
        var ol = h("ol", "ib-dk-sheet__numbered");
        sec.items.forEach(function (it) { ol.appendChild(h("li", null, it.text)); });
        s.appendChild(ol);
      } else if (sec.kind === "detailRows") {
        sec.rows.forEach(function (row) {
          var r = h("div", "ib-dk-sheet__detail-row");
          r.appendChild(h("p", "ib-dk-sheet__detail-term", row.term));
          if (row.text) r.appendChild(h("p", "ib-dk-sheet__detail-body", row.text));
          if (row.quote) {
            var q = h("p", "ib-dk-sheet__verbatim");
            q.appendChild(h("em", null, S.sheet.inHerWords + "“" + row.quote + "”"));
            r.appendChild(q);
          }
          s.appendChild(r);
        });
      } else if (sec.kind === "groupedList") {
        sec.groups.forEach(function (g) {
          var p = h("p", "ib-dk-sheet__group");
          p.appendChild(h("strong", null, g.title + ": "));
          p.appendChild(document.createTextNode(g.items.join("; ")));
          s.appendChild(p);
        });
        (sec.extras || []).forEach(function (ex) {
          var q = h("p", "ib-dk-sheet__verbatim");
          q.appendChild(h("em", null, S.sheet.inHerWords + "“" + ex.text + "”"));
          s.appendChild(q);
        });
      } else if (sec.kind === "paragraphs") {
        sec.items.forEach(function (it) {
          if (it.verbatim) {
            var q = h("p", "ib-dk-sheet__verbatim");
            q.appendChild(h("em", null, S.sheet.inHerWords + "“" + it.text + "”"));
            s.appendChild(q);
          } else {
            s.appendChild(h("p", null, it.text));
          }
        });
      } else { /* line */
        s.appendChild(h("p", null, sec.text));
      }
      root.appendChild(s);
    });

    var foot = h("footer", "ib-dk-sheet__footer");
    foot.appendChild(h("p", null, S.sheet.footerCredit));
    foot.appendChild(h("p", null, S.sheet.footerDisclaimer));
    root.appendChild(foot);
  }

  /* ================================================================ reveal */
  var currentModel = null;
  function reveal() {
    showView("ib-dk-transition");
    state.screen = "reveal";
    save();
    window.setTimeout(function () {
      currentModel = buildSheetModel(state.answers);
      renderSheetDOM(currentModel);
      showView("ib-dk-reveal");
      track("kit_sheet_view");
      pdf.prepare(); /* fire-and-forget: lazy jsPDF + fonts + fit check */
    }, prefersReducedMotion() ? 0 : 1100);
  }
  function prefersReducedMotion() {
    try { return window.matchMedia("(prefers-reduced-motion: reduce)").matches; }
    catch (e) { return false; }
  }

  /* ============================================================== PDF */
  var pdf = (function () {
    var readyPromise = null;
    var fonts = { regular: null, bold: null, failed: false };
    var plan = null; /* { steps: n, truncated: bool } */

    function loadScript(src) {
      return new Promise(function (resolve, reject) {
        if (window.jspdf) { resolve(); return; }
        var sc = document.createElement("script");
        sc.src = src;
        sc.onload = resolve;
        sc.onerror = reject;
        document.head.appendChild(sc);
      });
    }
    function fetchB64(url) {
      return fetch(url).then(function (r) {
        if (!r.ok) throw new Error("font fetch failed");
        return r.arrayBuffer();
      }).then(function (buf) {
        var bytes = new Uint8Array(buf);
        var bin = "";
        var CHUNK = 0x8000;
        for (var i = 0; i < bytes.length; i += CHUNK) {
          bin += String.fromCharCode.apply(null, bytes.subarray(i, i + CHUNK));
        }
        return btoa(bin);
      });
    }
    function ensureReady() {
      if (!readyPromise) {
        readyPromise = loadScript(CONFIG.assets.jspdf).then(function () {
          return Promise.all([fetchB64(CONFIG.assets.fontRegular), fetchB64(CONFIG.assets.fontBold)])
            .then(function (res) { fonts.regular = res[0]; fonts.bold = res[1]; })
            .catch(function () {
              fonts.failed = true;
              track("kit_pdf_font_fallback");
            });
        });
      }
      return readyPromise;
    }
    function newDoc() {
      var doc = new window.jspdf.jsPDF({ unit: "pt", format: "letter" });
      if (!fonts.failed && fonts.regular && fonts.bold) {
        doc.addFileToVFS("DMSans-Regular.ttf", fonts.regular);
        doc.addFont("DMSans-Regular.ttf", "DMSans", "normal");
        doc.addFileToVFS("DMSans-Bold.ttf", fonts.bold);
        doc.addFont("DMSans-Bold.ttf", "DMSans", "bold");
      }
      return doc;
    }
    function fontName() { return fonts.failed || !fonts.regular ? "helvetica" : "DMSans"; }

    var PAGE = { w: 612, h: 792, margin: 44 };
    var INK = [27, 34, 37];      /* Space Black */
    var SLATE = [57, 91, 97];    /* Slate Grey */
    var GREEN = [120, 157, 44];  /* Stability Green */

    /* Compression ladder (§6.4). Returns a transformed copy of the model. */
    function compress(model, step) {
      var m = JSON.parse(JSON.stringify(model));
      if (step >= 1) { /* drop quotes beyond the first symptom quote */
        var seen = false;
        m.sections.forEach(function (sec) {
          if (sec.kind !== "detailRows") return;
          sec.rows.forEach(function (r) {
            if (r.quote) { if (seen) r.quote = ""; seen = true; }
          });
        });
      }
      if (step >= 2) { /* collapse Additional Symptoms to one comma-run paragraph */
        m.sections.forEach(function (sec) {
          if (sec.id !== "additional") return;
          var all = [];
          sec.groups.forEach(function (g) { all = all.concat(g.items); });
          sec.kind = "line";
          sec.text = all.join("; ") + ".";
          sec.groups = [];
        });
      }
      if (step >= 4) { /* truncate the D6 note with a visible ellipsis */
        m.sections.forEach(function (sec) {
          (sec.items || []).forEach(function (it) {
            if (it.truncatable && it.text.length > 140) {
              it.text = it.text.slice(0, 140).replace(/\s+\S*$/, "") + "…";
              m._truncated = true;
            }
          });
        });
      }
      m._body = step >= 5 ? 8.5 : step >= 3 ? 9 : 9.5;
      m._gap = step >= 3 ? 10 : 13;
      return m;
    }

    /* Shared layout walk. dry=true only measures; returns final y. */
    function drawSheet(doc, m, dry) {
      var body = m._body || 9.5;
      var gap = m._gap || 13;
      var lh = body * 1.35;
      var x = PAGE.margin;
      var w = PAGE.w - PAGE.margin * 2;
      var y = PAGE.margin + 12;
      var footerY = PAGE.h - PAGE.margin;
      var f = fontName();

      function text(str, size, style, color, tx, maxW, lineH) {
        var lines = doc.splitTextToSize(str, maxW || w);
        if (!dry) {
          doc.setFont(f, style || "normal");
          doc.setFontSize(size);
          doc.setTextColor(color[0], color[1], color[2]);
          doc.text(lines, tx || x, y);
        } else {
          doc.setFont(f, style || "normal");
          doc.setFontSize(size);
        }
        y += lines.length * (lineH || size * 1.35);
      }

      /* header band */
      doc.setFont(f, "bold"); doc.setFontSize(16);
      if (!dry) {
        doc.setTextColor(INK[0], INK[1], INK[2]);
        doc.text(S.sheet.title, x, y);
        doc.setFont(f, "normal"); doc.setFontSize(9);
        doc.setTextColor(SLATE[0], SLATE[1], SLATE[2]);
        doc.text(m.dateLabel, PAGE.w - PAGE.margin, y, { align: "right" });
      }
      y += 20;
      if (!dry) {
        doc.setFont(f, "normal"); doc.setFontSize(9.5);
        doc.setTextColor(INK[0], INK[1], INK[2]);
        doc.text(S.sheet.nameField, x, y);
        doc.setDrawColor(SLATE[0], SLATE[1], SLATE[2]);
        doc.setLineWidth(0.5);
        doc.line(x + 32, y + 1.5, x + 250, y + 1.5);
        doc.text(S.sheet.dobField, x + 270, y);
        doc.line(x + 296, y + 1.5, x + 420, y + 1.5);
      }
      y += 10;
      if (!dry) {
        doc.setDrawColor(GREEN[0], GREEN[1], GREEN[2]);
        doc.setLineWidth(1.2);
        doc.line(x, y, PAGE.w - PAGE.margin, y);
      }
      y += gap + 2;

      m.sections.forEach(function (sec) {
        /* section heading */
        if (!dry) { doc.setCharSpace && doc.setCharSpace(0.5); }
        text(sec.title.toUpperCase(), body === 8.5 ? 9.5 : 10.5, "bold", INK, x, w, (body === 8.5 ? 9.5 : 10.5) * 1.2);
        if (!dry) { doc.setCharSpace && doc.setCharSpace(0); }
        y += 2;

        if (sec.kind === "numbered") {
          sec.items.forEach(function (it, i) {
            text((i + 1) + ". " + it.text, sec.lead ? body + 0.5 : body, sec.lead ? "bold" : "normal", INK, x + 4, w - 8, lh);
            y += 1.5;
          });
        } else if (sec.kind === "detailRows") {
          sec.rows.forEach(function (r) {
            text(r.term, body, "bold", INK, x + 4, w - 8, lh);
            if (r.text) text(r.text, body, "normal", INK, x + 4, w - 8, lh);
            if (r.quote) {
              text(S.sheet.inHerWords + "“" + r.quote + "”", body - 0.5, "normal", SLATE, x + 14, w - 22, (body - 0.5) * 1.35);
            }
            y += 2.5;
          });
        } else if (sec.kind === "groupedList") {
          sec.groups.forEach(function (g) {
            text(g.title + ": " + g.items.join("; "), body, "normal", INK, x + 4, w - 8, lh);
            y += 1.5;
          });
          (sec.extras || []).forEach(function (ex) {
            text(S.sheet.inHerWords + "“" + ex.text + "”", body - 0.5, "normal", SLATE, x + 14, w - 22, (body - 0.5) * 1.35);
          });
        } else if (sec.kind === "paragraphs") {
          sec.items.forEach(function (it) {
            if (it.verbatim) {
              text(S.sheet.inHerWords + "“" + it.text + "”", body - 0.5, "normal", SLATE, x + 14, w - 22, (body - 0.5) * 1.35);
            } else {
              text(it.text, body, "normal", INK, x + 4, w - 8, lh);
            }
            y += 1;
          });
        } else { /* line */
          text(sec.text, body, "normal", INK, x + 4, w - 8, lh);
        }
        y += gap;
      });

      /* footer pinned to bottom */
      if (!dry) {
        doc.setFont(f, "normal"); doc.setFontSize(7.5);
        doc.setTextColor(SLATE[0], SLATE[1], SLATE[2]);
        doc.text(S.sheet.footerCredit, x, footerY - 10);
        doc.text(S.sheet.footerDisclaimer, x, footerY);
      }
      return y;
    }

    var FOOTER_CLEAR = 26;
    function computePlan(model) {
      var doc = newDoc(); /* scratch doc for measurement */
      for (var step = 0; step <= 5; step++) {
        var m = compress(model, step);
        var endY = drawSheet(doc, m, true);
        if (endY <= PAGE.h - PAGE.margin - FOOTER_CLEAR) {
          return { step: step, truncated: !!m._truncated };
        }
      }
      return { step: 5, truncated: true };
    }

    function prepare() {
      ensureReady().then(function () {
        if (!window.jspdf || !currentModel) return;
        try { plan = computePlan(currentModel); } catch (e) { plan = { step: 0, truncated: false }; }
        var note = byId("ib-dk-truncation-note");
        if (note && plan.truncated) {
          note.textContent = S.reveal.truncationNote;
          note.hidden = false;
        }
      }).catch(function () { /* handled at download time */ });
    }

    function isConstrainedBrowser() {
      var ua = navigator.userAgent || "";
      var iOS = /iPhone|iPad|iPod/.test(ua) || (navigator.platform === "MacIntel" && navigator.maxTouchPoints > 1);
      var inApp = /Instagram|FBAN|FBAV|FB_IAB|Line\/|MicroMessenger/.test(ua);
      return { iOS: iOS, inApp: inApp };
    }

    /* Deliver the PDF from its blob. jsPDF's own doc.save() bundles a file-saver
       that some desktop browsers/extensions block or throw on; building the
       download ourselves from the (verified-good) blob is more reliable, with a
       new-tab fallback for iOS / in-app webviews. */
    function deliverPdf(doc, name) {
      var blob = doc.output("blob");
      var url = URL.createObjectURL(blob);
      window.setTimeout(function () { URL.revokeObjectURL(url); }, 60000);
      var env = isConstrainedBrowser();
      var a = document.createElement("a");
      if (("download" in a) && !env.iOS && !env.inApp) {
        a.href = url; a.download = name; a.rel = "noopener";
        document.body.appendChild(a); a.click(); document.body.removeChild(a);
        return "ok";
      }
      var w = window.open(url, "_blank");
      return w ? "newtab" : "blocked";
    }

    function download() {
      var help = byId("ib-dk-download-help");
      return ensureReady().then(function () {
        if (!window.jspdf) throw new Error("jspdf unavailable");
        if (!plan) plan = computePlan(currentModel);
        var m = compress(currentModel, plan.step);
        var doc = newDoc();
        drawSheet(doc, m, false);
        var stamp = new Date().toISOString().slice(0, 10);
        var name = "Doctor-Visit-Sheet-" + stamp + ".pdf";
        var mode = deliverPdf(doc, name);
        if (help) {
          if (mode === "ok") { help.hidden = true; help.textContent = ""; }
          else if (mode === "newtab") { help.textContent = S.download.iosHint; help.hidden = false; }
          else { help.textContent = S.download.blocked; help.hidden = false; }
        }
        track("kit_pdf_download");
        return true;
      }).catch(function (e) {
        try { console.warn("[IB Doctor Kit] PDF export failed:", e); } catch (_) {}
        if (help) { help.textContent = S.download.blocked; help.hidden = false; }
        return false;
      });
    }

    return { prepare: prepare, download: download };
  })();

  /* ============================================================== share */
  function shareUrl() {
    var payload = window.LZString.compressToEncodedURIComponent(JSON.stringify(state.answers));
    var url = location.origin + location.pathname + "?k=" + payload;
    if (url.length > 1800) track("kit_share_long_url");
    return url;
  }
  function doShare() {
    var url = shareUrl();
    var done = function () { track("kit_share"); showAfter(); };
    if (navigator.share) {
      navigator.share({ title: S.share.shareTitle, url: url }).then(done).catch(function () { /* cancelled */ });
    } else if (navigator.clipboard && navigator.clipboard.writeText) {
      navigator.clipboard.writeText(url).then(function () {
        flashShareNote(S.share.copied);
        done();
      }).catch(function () { manualCopy(url); done(); });
    } else {
      manualCopy(url);
      done();
    }
  }
  function flashShareNote(msg) {
    var help = byId("ib-dk-download-help");
    if (help) { help.textContent = msg; help.hidden = false; }
  }
  function manualCopy(url) {
    var help = byId("ib-dk-download-help");
    if (!help) return;
    help.textContent = "";
    help.appendChild(h("p", null, S.share.copyFail));
    var input = h("input", "ib-dk-input");
    input.type = "text";
    input.readOnly = true;
    input.value = url;
    input.addEventListener("focus", function () { input.select(); });
    help.appendChild(input);
    help.hidden = false;
  }

  /* ====================================================== post-download */
  function showAfter() {
    var root = byId("ib-dk-after");
    root.textContent = "";
    var wrap = h("div", "ib-dk-after");
    wrap.appendChild(h("h2", "ib-dk-after__head", S.after.head));
    wrap.appendChild(h("p", "ib-dk-after__body", S.after.body));

    var which = pickProduct(state.answers);
    if (which !== "none") {
      var card = DATA.products.cards[which];
      var url = CONFIG[card.urlKey] || "";
      var cardEl = h("div", "ib-dk-product-card ib-dk-product-card--" + which);
      cardEl.appendChild(h("p", "ib-dk-product-card__body", card.body));
      if (url) {
        var link = h("a", "ib-dk-product-card__link", card.link);
        link.href = url;
        link.addEventListener("click", function () { track("kit_stability_card_click"); });
        cardEl.appendChild(link);
      }
      wrap.appendChild(cardEl);
      wrap.appendChild(h("p", "ib-dk-fda", DATA.products.fdaDisclaimer));
      track("kit_stability_card_view");
    }

    var links = h("div", "ib-dk-after__links");
    links.appendChild(btn("ib-dk-btn ib-dk-btn--secondary", S.after.downloadAgain, function () {
      showView("ib-dk-reveal");
    }));
    links.appendChild(btn("ib-dk-btn ib-dk-btn--link", S.after.friend, function () {
      clearSaved();
      state.answers = freshAnswers();
      state.history = [];
      state.screen = "intro";
      var help = byId("ib-dk-download-help");
      if (help) help.hidden = true;
      var note = byId("ib-dk-truncation-note");
      if (note) note.hidden = true;
      showView("ib-dk-intro");
    }));
    if (CONFIG.showBlogLink && CONFIG.blogLinkUrl) {
      var blog = h("a", "ib-dk-after__blog", CONFIG.blogLinkLabel);
      blog.href = CONFIG.blogLinkUrl;
      links.appendChild(blog);
    }
    wrap.appendChild(links);
    root.appendChild(wrap);
    showView("ib-dk-after");
  }

  /* ============================================================== decode */
  function truncate(str, n) { return typeof str === "string" ? str.slice(0, n) : ""; }
  function sanitizeAnswers(raw) {
    if (!raw || typeof raw !== "object" || raw.v !== 1) return null;
    var a = freshAnswers();
    var validSym = function (id) { return !!SYM[id] || id === "other"; };
    a.sym = Array.isArray(raw.sym) ? raw.sym.filter(validSym) : [];
    a.symO = truncate(raw.symO, 200);
    a.pri = (Array.isArray(raw.pri) ? raw.pri : [])
      .filter(function (id) { return a.sym.indexOf(id) !== -1; })
      .slice(0, 3);
    if (raw.det && typeof raw.det === "object") {
      a.pri.forEach(function (id) {
        var d = raw.det[id];
        if (!d || typeof d !== "object") return;
        a.det[id] = {
          dur: typeof d.dur === "string" ? d.dur : "",
          freq: typeof d.freq === "string" ? d.freq : "",
          pat: Array.isArray(d.pat) ? d.pat.filter(function (x) { return typeof x === "string"; }) : [],
          cost: Array.isArray(d.cost) ? d.cost.filter(function (x) { return typeof x === "string"; }) : [],
          txt: truncate(d.txt, 200)
        };
      });
    }
    if (raw.tried && typeof raw.tried === "object") {
      a.tried.c = Array.isArray(raw.tried.c) ? raw.tried.c.filter(function (id) { return !!TRIED[id] || id === "everything"; }) : [];
      a.tried.o = truncate(raw.tried.o, 200);
      a.tried.out = typeof raw.tried.out === "string" ? raw.tried.out : "";
    }
    if (raw.meds && typeof raw.meds === "object") {
      a.meds.t = truncate(raw.meds.t, 300);
      a.meds.none = !!raw.meds.none;
    }
    a.cyc = CYCLE[raw.cyc] ? raw.cyc : "";
    if (raw.goal && typeof raw.goal === "object") {
      a.goal.c = typeof raw.goal.c === "string" ? raw.goal.c : "";
      a.goal.t = truncate(raw.goal.t, 200);
    }
    if (raw.deep && typeof raw.deep === "object") {
      a.deep = {
        sweep: Array.isArray(raw.deep.sweep) ? raw.deep.sweep.filter(function (id) { return !!DEEP_ITEMS[id]; }) : [],
        sleep: {
          hrs: raw.deep.sleep && typeof raw.deep.sleep.hrs === "string" ? raw.deep.sleep.hrs : "",
          wakes: raw.deep.sleep && typeof raw.deep.sleep.wakes === "string" ? raw.deep.sleep.wakes : "",
          when: raw.deep.sleep && typeof raw.deep.sleep.when === "string" ? raw.deep.sleep.when : ""
        },
        wt: {
          chg: raw.deep.wt && typeof raw.deep.wt.chg === "string" ? raw.deep.wt.chg : "",
          habits: raw.deep.wt && typeof raw.deep.wt.habits === "string" ? raw.deep.wt.habits : ""
        },
        fam: Array.isArray(raw.deep.fam) ? raw.deep.fam.filter(function (id) { return !!FAMILY[id]; }) : [],
        prior: typeof raw.deep.prior === "string" ? raw.deep.prior : "",
        note: truncate(raw.deep.note, 300)
      };
    }
    if (!a.sym.length) return null;
    return a;
  }
  function tryDecodeShareLink() {
    var match = /[?&]k=([^&]+)/.exec(location.search);
    if (!match) return false;
    var answers = null;
    try {
      var json = window.LZString.decompressFromEncodedURIComponent(match[1]);
      answers = sanitizeAnswers(JSON.parse(json));
    } catch (e) { answers = null; }
    if (!answers) {
      try { history.replaceState(null, "", location.pathname); } catch (e) { /* noop */ }
      return false;
    }
    state.answers = answers;
    state.fromShare = true;
    state.screen = "reveal";
    currentModel = buildSheetModel(answers);
    renderSheetDOM(currentModel);
    showView("ib-dk-reveal");
    track("kit_sheet_view");
    track("kit_step", "shared_sheet");
    pdf.prepare();
    return true;
  }

  /* ---------------------------------------------------------- dev hooks */
  function mockAnswers() {
    var a = freshAnswers();
    a.sym = ["sleep_3am", "hot_flashes", "night_sweats", "rage", "anxiety", "mood_swings", "brain_fog", "fatigue", "weight_middle", "low_libido", "irregular_periods", "heavy_periods", "palpitations", "joint_aches", "headaches", "other"];
    a.symO = "A buzzing / vibrating feeling in my chest at night that nobody can explain, it wakes me up and scares me";
    a.pri = ["sleep_3am", "rage", "brain_fog"];
    a.det = {
      sleep_3am: { dur: "1_2y", freq: "most_days", pat: ["night", "worse"], cost: ["sleep", "work", "self"], txt: "I lie there doing math on how little sleep I'll get. By 5am I'm furious and exhausted at the same time." },
      rage: { dur: "6_12mo", freq: "few_week", pat: ["cycle", "stress"], cost: ["rel", "fam"], txt: "I hear myself snap at my kids and it doesn't even sound like me." },
      brain_fog: { dur: "6_12mo", freq: "daily", pat: ["worse"], cost: ["work", "self"], txt: "I lost the word 'refrigerator' in a meeting. I run meetings." }
    };
    a.tried = { c: ["diet", "fasting", "exercise", "meditation", "sleep_hyg", "cut_alc", "supps", "therapy", "everything"], o: "Magnesium glycinate, ashwagandha, a $40 sleep tracker ring", out: "nothing_stuck" };
    a.meds = { t: "Levothyroxine 50mcg daily. Vitamin D 2000IU. Fish oil. Occasional melatonin 5mg.", none: false };
    a.cyc = "rogue";
    a.goal = { c: "serious", t: "I want to leave with something written down, not a shrug." };
    a.deep = {
      sweep: ["irritability", "low_mood", "panic", "memory", "flooding", "breast_tender", "chills", "sugar_crave", "pm_crash", "snoring", "restless_legs", "dryness", "dyspareunia", "urgency"],
      sleep: { hrs: "5_6", wakes: "2", when: "2_4" },
      wt: { chg: "5_15", habits: "same" },
      fam: ["early_meno", "osteoporosis", "thyroid"],
      prior: "stress",
      note: "Two different doctors have told me this is just what 47 feels like. I do not accept that as a complete answer, and I'd like this visit to go differently. I keep a symptom diary on my phone if it's useful."
    };
    return a;
  }
  function tryDevHooks() {
    var mock = /[?&]dk_mock=full/.test(location.search);
    var screenMatch = /[?&]dk_screen=([a-z0-9:_]+)/.exec(location.search);
    if (!mock && !screenMatch) return false;
    state.answers = mockAnswers();
    if (mock) {
      state.screen = "reveal";
      currentModel = buildSheetModel(state.answers);
      renderSheetDOM(currentModel);
      showView("ib-dk-reveal");
      pdf.prepare();
      return true;
    }
    go(screenMatch[1].replace("_", ":"));
    return true;
  }

  /* ================================================================ boot */
  function wireStaticActions(root) {
    root.addEventListener("click", function (ev) {
      var target = ev.target.closest ? ev.target.closest("[data-dk-action]") : null;
      if (!target) return;
      var action = target.getAttribute("data-dk-action");
      if (action === "start") {
        track("kit_start");
        var saved = load();
        if (saved && saved.screen && saved.screen !== "intro" && saved.answers.sym.length) {
          state.answers = saved.answers;
          state.history = saved.history || [];
          if (saved.screen === "reveal") { reveal(); return; }
          go(saved.screen, { silent: false });
        } else {
          go("s1");
        }
      } else if (action === "download") {
        pdf.download().then(function (ok) { if (ok) showAfter(); });
      } else if (action === "share") {
        doShare();
      } else if (action === "edit") {
        track("kit_edit_answers");
        state.history = [];
        go("s1");
      } else if (action === "print") {
        document.documentElement.classList.add("ib-dk-printing");
        window.setTimeout(function () {
          window.print();
          document.documentElement.classList.remove("ib-dk-printing");
        }, 50);
      }
    });
  }

  var booted = false;
  function init() {
    var root = document.getElementById("ib-dk");
    if (!root || booted) return;
    booted = true;
    wireStaticActions(root);
    if (tryDevHooks()) return;
    if (tryDecodeShareLink()) return;
    /* If she has mid-flow progress, surface it on the intro CTA */
    var saved = load();
    if (saved && saved.screen && saved.screen !== "intro") {
      var cta = root.querySelector(".ib-dk-intro__cta");
      if (cta) cta.textContent = S.resumeYes;
    }
    showView("ib-dk-intro");
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", init);
  } else {
    init();
  }
  /* Shopify theme editor reloads sections without a page load */
  document.addEventListener("shopify:section:load", function () {
    booted = false;
    init();
  });
})();
